import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IControllerSlice } from "interfaces";

const ControllerSliceState: IControllerSlice = {
    play: false,
    isAutoPlay: true,
    duration: 0,
    currentTime: 0,
    mouseMoveTime: 0,
    qualityLevels: [],
    qualityBitrates: [],
    manualQuality: undefined,
    autoQuality: undefined,
    activeElements: true,
    isLive: false,
    isLoading: false,
    isFullScreen: false,
    bufferedTimeWidth: 0,
    firstPlay: true,
    hlsLiveSyncPosition: 0,
    activePointerProgressBar: false,
    delayTurnOffControlbar: false,
    canPlayVideo: false,
    lock: false,
    isEnded: false,
    tooltipTime: 0,
    showMiniPlayer: false,
    isClickInnerCard: false,
    loadedFragmentsCount: []
};

export const controllerSlice = createSlice({
    name: "controller",
    initialState: ControllerSliceState,
    reducers: {
        setPlay: (state, action: PayloadAction<boolean>) => {
            state.play = action.payload;
        },
        setIsAutoPlay: (state, action: PayloadAction<boolean>) => {
            state.isAutoPlay = action.payload;
        },
        setDuration: (state, action: PayloadAction<number>) => {
            state.duration = action.payload;
        },
        setCurrentTime: (state, action: PayloadAction<number>) => {
            state.currentTime = action.payload;
        },
        setMouseMoveTime: (state, action: PayloadAction<number>) => {
            state.mouseMoveTime = action.payload;
        },
        setManualQuality: (state, action: PayloadAction<number | undefined>) => {
            state.manualQuality = action.payload;
        },
        setAutoQuality: (state, action: PayloadAction<number | undefined>) => {
            state.autoQuality = action.payload;
        },
        setQualityLevels: (state, action: PayloadAction<any[]>) => {
            state.qualityLevels = action.payload;
        },
        setQualityBitrates: (state, action: PayloadAction<string[]>) => {
            state.qualityBitrates = action.payload;
        },
        setActiveElements: (state, action: PayloadAction<boolean>) => {
            state.activeElements = action.payload;
        },
        setIsLive: (state, action: PayloadAction<boolean>) => {
            state.isLive = action.payload;
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setIsFullScreen: (state, action: PayloadAction<boolean>) => {
            state.isFullScreen = action.payload;
        },
        setBufferedTimeWidth: (state, action: PayloadAction<number>) => {
            state.bufferedTimeWidth = action.payload;
        },
        setFirstPlay: (state, action: PayloadAction<boolean>) => {
            state.firstPlay = action.payload;
        },
        setHlsLivePosition: (state, action: PayloadAction<any>) => {
            state.hlsLiveSyncPosition = action.payload;
        },
        setActivePointerProgressBar: (state, action: PayloadAction<boolean>) => {
            state.activePointerProgressBar = action.payload;
        },
        setDelayTurnOffControlbar: (state, action: PayloadAction<boolean>) => {
            state.delayTurnOffControlbar = action.payload;
        },
        setCanPlayVideo: (state, action: PayloadAction<boolean>) => {
            state.canPlayVideo = action.payload;
        },
        setLock: (state, action: PayloadAction<boolean>) => {
            state.lock = action.payload;
        },
        setIsEnded: (state, action: PayloadAction<boolean>) => {
            state.isEnded = action.payload;
        },
        setTooltipTime: (state, action: PayloadAction<number>) => {
            state.tooltipTime = action.payload;
        },
        setShowMiniPlayer: (state, action: PayloadAction<boolean | undefined>) => {
            state.showMiniPlayer = action.payload;
        },
        setIsClickInnerCard: (state, action: PayloadAction<boolean>) => {
            state.isClickInnerCard = action.payload;
        },
        setLoadedFragmentsCount: (state, action: PayloadAction<number[]>) => {
            state.loadedFragmentsCount = action.payload;
        },
        setClearControllerSlice: () => {
            return ControllerSliceState;
        }
    }
});

export const {
    setPlay,
    setIsAutoPlay,
    setDuration,
    setCurrentTime,
    setMouseMoveTime,
    setQualityLevels,
    setQualityBitrates,
    setAutoQuality,
    setActiveElements,
    setIsLive,
    setIsLoading,
    setIsFullScreen,
    setBufferedTimeWidth,
    setFirstPlay,
    setHlsLivePosition,
    setActivePointerProgressBar,
    setDelayTurnOffControlbar,
    setManualQuality,
    setCanPlayVideo,
    setLock,
    setIsEnded,
    setTooltipTime,
    setShowMiniPlayer,
    setClearControllerSlice,
    setIsClickInnerCard,
    setLoadedFragmentsCount
} = controllerSlice.actions;
export default controllerSlice.reducer;
